import { useSuspenseFetchUser as useSharedSuspenseFetchUser } from '@avanta/shared/hooks/useSuspenseFetchUser';
import { useUserStore } from 'stores/user';
import { useChat } from './useChat';

export const useSuspenseFetchUser = (): void => {
  const setUser = useUserStore(state => state.setUser);
  const user = useSharedSuspenseFetchUser({ setUser });
  useChat(user.id);
};
